import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { ProtectedRoute } from "@/components/site/ProtectedRoute";
import Landing from "@/pages/Landing";
import Properties from "@/pages/Properties";
import CompletedDeals from "@/pages/CompletedDeals";
import AuthPage from "@/pages/AuthPage";
import BuyPage from "@/pages/BuyPage";
import SellPage from "@/pages/SellPage";
import Portal from "@/pages/Portal";
import Admin from "@/pages/Admin";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/properties" element={<Properties />} />
              <Route path="/completed" element={<CompletedDeals />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/buy" element={<BuyPage />} />
              <Route path="/sell" element={<SellPage />} />
              <Route path="/portal" element={<ProtectedRoute><Portal /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute admin><Admin /></ProtectedRoute>} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="bottom-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
